export default __webpack_public_path__ + "static/media/scss-logo.672732e2.png";